module.exports = __webpack_public_path__ + "img/value-equal.e76e30eb.svg";